import React from 'react';

const ErrorNotFound = () => (<h2>Sorry, we couldn&apos;t find that page.</h2>);

export default ErrorNotFound;
